$.namespace("SCS.downloadbutton");
SCS.downloadbutton.buttonClick = function(openInNewWindow, resourceURL, nodeId) {
	if (openInNewWindow != 'true') {
		$("#scs-help-downloadStartLink-" + nodeId).css("display", "block");
		window.open(resourceURL, "_self");
	} else {
		window.open(resourceURL, "_blank");
	}
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/downloadbutton.js
// module id = 341
// module chunks = 0